<template>
  <el-dialog
    class="cus-dialog-container previewMobileDialog"
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    destroy-on-close
    :show-close="false"
    append-to-body
    center
    :width="width"
    ref="elDialog"
    :id="id"
  >
    <span v-if="show">
      <div class="mobileTitleWrapper">
        <span @click="mobileback" style="cursor: pointer">
          <i class="el-icon-arrow-left"></i>返回
        </span>
        <span style="color: #323233">{{ mobileTitle }}</span>
        <span @click="close" style="cursor: pointer">关闭</span>
      </div>

      <slot></slot>
    </span>
  </el-dialog>
</template>

<script>
import { config } from '@/config/config'
export default {
  name: 'cus-dialog',
  props: {
    visible: Boolean,
    loadingText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '600px',
    },
    form: {
      type: Boolean,
      default: true,
    },
    action: {
      type: Boolean,
      default: true,
    },
    mobileData: {
      type: Object,
      default: () => {
        return {
          widgetForm: null,
          widgetModels: null,
          currentUser: null,
          remoteFuncs: null,
        }
      },
    },
  },
  computed: {
    show() {
      if (this.form) {
        return this.showForm
      } else {
        return true
      }
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: this.visible,
      id: 'dialog_' + new Date().getTime(),
      showForm: false,
      mobileTitle: 'H5生成器',
    }
  },

  created() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessag)
  },
  methods: {
    mobileback() {
      const iframe = document.querySelector('#mobileIframe')
      iframe.contentWindow.postMessage({ type: 'mobileback' }, '*')
    },
    handleMessage(e) {
      if (e.data.type === 'title:change') {
        this.mobileTitle = e.data.data
      }
      if (e.data.type === 'mobileStatus' && e.data.data === 'ok') {
        const mobileData = {
          ...this.mobileData,
          config: config,
        }
        const iframe = document.querySelector('#mobileIframe')
        iframe.contentWindow.postMessage(
          { type: 'mobileData', data: JSON.stringify(mobileData) },
          '*'
        )
      }
    },
    close() {
      this.dialogVisible = false
    },
    submit() {
      this.loading = true

      this.$emit('on-submit')
    },
    end() {
      this.loading = false
    },
  },
  mounted() {},
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.loading = false
        this.$emit('on-close')
        setTimeout(() => {
          this.showForm = false
        }, 300)
      } else {
        this.showForm = true
      }
    },
    visible(val) {
      this.dialogVisible = val
    },
  },
}
</script>

<style lang="scss">
.cus-dialog-container {
  .el-dialog__footer {
    margin: 0 20px;
    // border-top: 1px dashed #ccc;
    padding: 15px 0 16px;
    text-align: center;
    position: relative;

    .dialog-footer {
      display: block;

      .circular {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        height: 24px;
      }

      .el-loading-text {
        display: inline-block;
        vertical-align: middle;
      }

      .el-loading-spinner {
        margin-top: -12px;
      }
    }
  }
}
.previewMobileDialog .el-dialog__body {
  padding: 0;
  overflow: hidden;
}
.previewMobileDialog .el-dialog__header {
  padding: 0;
}
.mobileTitleWrapper {
  box-sizing: border-box;
  height: 46px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1989fa;
}
</style>
